var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ValidationObserver', {
    ref: "observer",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var handleSubmit = _ref.handleSubmit;
        return [_c('form', {
          on: {
            "submit": function submit($event) {
              $event.preventDefault();
              return handleSubmit(_vm.submit);
            }
          }
        }, [_c('div', {
          staticClass: "form-group row mt-4"
        }, [_vm.fields[0] ? _c('reg-input-text', {
          attrs: {
            "label": "Email Address",
            "type": "email",
            "form": _vm.form,
            "field": _vm.fields[0],
            "placeholder": "Enter Email Address",
            "formGroupClass": "col-xxl-12 mb-2",
            "rules": {
              required: _vm.fields[0].required,
              email: true
            }
          }
        }) : _vm._e(), _vm.showOtpSectionEmail ? _c('span', {
          staticClass: "validate-btn col-md-5 col-sm-6 d-flex rep-reg-otp-validation mb-2",
          staticStyle: {
            "margin-left": "3px"
          }
        }, [_c('a', {
          staticClass: "validate-via-otp-link ",
          attrs: {
            "href": "#"
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.openOtpModal('email');
            }
          }
        }, [_vm._v(" TO CONTINUE, PLEASE CLICK HERE TO VERIFY YOUR EMAIL. ")])]) : _vm._e()], 1), _vm.emailMsg ? _c('div', {
          staticClass: "contact-message-container form-group"
        }, [_c('div', {
          class: ['validate-message mt-2', _vm.emailValidationMessage.type]
        }, [_c('div', {
          class: ['message-indicator', "".concat(_vm.emailValidationMessage.type, "-indicator")]
        }), _c('span', {
          staticClass: "message-text"
        }, [_c('strong', {
          class: "".concat(_vm.emailValidationMessage.type, "-text")
        }, [_vm._v(_vm._s(_vm.emailValidationMessage.title))]), _vm._v(" - " + _vm._s(_vm.emailValidationMessage.message) + " ")])])]) : _vm._e(), _c('div', {
          staticClass: "d-flex align-items-center mb-3 mt-4"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: _vm.isChecked,
            expression: "isChecked"
          }],
          staticClass: "mb-1",
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": Array.isArray(_vm.isChecked) ? _vm._i(_vm.isChecked, null) > -1 : _vm.isChecked
          },
          on: {
            "change": function change($event) {
              var $$a = _vm.isChecked,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false;

              if (Array.isArray($$a)) {
                var $$v = null,
                    $$i = _vm._i($$a, $$v);

                if ($$el.checked) {
                  $$i < 0 && (_vm.isChecked = $$a.concat([$$v]));
                } else {
                  $$i > -1 && (_vm.isChecked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
                }
              } else {
                _vm.isChecked = $$c;
              }
            }
          }
        }), _c('label', {
          staticClass: "mb-0 ms-2"
        }, [_vm._v("Display Email Address")])]), _vm.isChecked ? _c('div', {
          staticClass: "form-group row mt-2"
        }, [_vm.fields[3] ? _c('reg-input-text', {
          attrs: {
            "label": "Display Email Address",
            "type": "email",
            "form": _vm.form,
            "field": _vm.fields[3],
            "placeholder": "Enter New Email Address",
            "formGroupClass": "col-xxl-12 mb-2"
          }
        }) : _vm._e(), _vm.showOtpSectionDisplayEmail ? _c('span', {
          staticClass: "validate-btn col-md-5 col-sm-6 d-flex ",
          staticStyle: {
            "margin-left": "3px"
          }
        }, [_c('a', {
          staticClass: "validate-via-otp-link ",
          attrs: {
            "href": "#"
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.openOtpModal('display_email');
            }
          }
        }, [_vm._v(" Validate via OTP ")])]) : _vm._e(), _vm.dispalyEmailMsg ? _c('div', {
          staticClass: "contact-message-container form-group"
        }, [_c('div', {
          class: ['validate-message mt-2', _vm.displayEmailValidationMessage.type]
        }, [_c('div', {
          class: ['message-indicator', "".concat(_vm.displayEmailValidationMessage.type, "-indicator")]
        }), _c('span', {
          staticClass: "message-text"
        }, [_c('strong', {
          class: "".concat(_vm.displayEmailValidationMessage.type, "-text")
        }, [_vm._v(_vm._s(_vm.displayEmailValidationMessage.title))]), _vm._v(" - " + _vm._s(_vm.displayEmailValidationMessage.message) + " ")])])]) : _vm._e()], 1) : _vm._e(), _c('div', {
          staticClass: "form-group row"
        }, [_vm.fields[1] ? _c('reg-input-text', {
          attrs: {
            "label": "Password",
            "type": "password",
            "form": _vm.form,
            "field": _vm.fields[1],
            "placeholder": "Password",
            "formGroupClass": "col-xxl-6 col-xl-6 col-lg-6 col-md-6 mb-4",
            "rules": {
              required: _vm.fields[1].required
            }
          },
          scopedSlots: _vm._u([{
            key: "appendIcon",
            fn: function fn() {
              return [_c('eye-button', {
                attrs: {
                  "id": "password",
                  "class-name": "toggle-password-icon",
                  "hide-on-default": true,
                  "type": "password"
                }
              })];
            },
            proxy: true
          }, {
            key: "shortMessage",
            fn: function fn() {
              return [!(_vm.apiErrors && _vm.apiErrors[_vm.fields[1].field_name]) ? _c('span', {
                staticClass: "short-msg"
              }, [_vm._v(" Password should be at least 8 characters long and include uppercase, lowercase, number & special character. and One Special Character ")]) : _vm._e()];
            },
            proxy: true
          }], null, true)
        }) : _vm._e(), _vm.fields[2] ? _c('reg-input-text', {
          attrs: {
            "label": "Confirm Password",
            "type": "password",
            "form": _vm.form,
            "field": _vm.fields[2],
            "placeholder": "Confirm Password",
            "api-errors": _vm.apiErrors,
            "formGroupClass": "col-xxl-6 col-xl-6 col-lg-6 col-md-6 mb-4",
            "rules": {
              required: _vm.fields[2].required
            }
          },
          scopedSlots: _vm._u([{
            key: "appendIcon",
            fn: function fn() {
              return [_c('eye-button', {
                attrs: {
                  "id": "password_confirmation",
                  "class-name": "toggle-password-icon",
                  "hide-on-default": true,
                  "type": "password"
                }
              })];
            },
            proxy: true
          }], null, true)
        }) : _vm._e(), _vm.passwordMsg ? _c('div', {
          staticClass: "contact-message-container form-group"
        }, [_c('div', {
          class: ['validate-message', _vm.passwordValidationMessage.type]
        }, [_c('div', {
          class: ['message-indicator', "".concat(_vm.passwordValidationMessage.type, "-indicator")]
        }), _c('span', {
          staticClass: "message-text"
        }, [_c('strong', {
          class: "".concat(_vm.passwordValidationMessage.type, "-text")
        }, [_vm._v(_vm._s(_vm.passwordValidationMessage.title))]), _vm._v(" - " + _vm._s(_vm.passwordValidationMessage.message) + " ")])])]) : _vm._e()], 1), _c('div', {
          staticClass: "action-btn split-action mt-5"
        }, [_c('button', {
          staticClass: "button-back",
          attrs: {
            "type": "button"
          },
          on: {
            "click": _vm.backHandler
          }
        }, [_vm._v("Back")]), _c('div', {
          staticClass: "action-next"
        }, [_c('button', {
          staticClass: "button-save",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.saveAndContinue.apply(null, arguments);
            }
          }
        }, [_vm._v(" Save & Continue Later ")]), _c('button', {
          staticClass: "button-submit",
          attrs: {
            "type": "submit"
          }
        }, [_vm._v("Next")])])])]), _vm.showOtpModal ? _c('RegistrationOTPModal', {
          attrs: {
            "identifier": _vm.contactInfo,
            "identifierTypeText": _vm.otpType,
            "field": _vm.field
          },
          on: {
            "save": _vm.handleVerificationResult,
            "close": _vm.closeOtpModal
          },
          model: {
            value: _vm.showOtpModal,
            callback: function callback($$v) {
              _vm.showOtpModal = $$v;
            },
            expression: "showOtpModal"
          }
        }) : _vm._e()];
      }
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }